<script>
    import { onMount, onDestroy, tick, createEventDispatcher } from 'svelte';
    import TomSelect from 'tom-select';
    import * as findingService from './v2-service.js';
    import { notificate } from '../../services/notification.js';
    import { flatten422Errors } from '../../services/api.svelte.js';
    import { translateErrorMessages } from '../../services/api.svelte.js';
    import { form as svForm, field } from "svelte-forms";
    import { required } from 'svelte-forms/validators';
    import CustomPropsFormElement from '../../components/custom-props-form-element.svelte';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    let {
        formData = $bindable({}),
        config = { edit: true },
        custom_vuls = [],
        customProps = $bindable([]),
        assets = [],
        onsave,
        oncancel
    } = $props();

    let assets_are_loading = $state(false);
    let props_errors = $state(null);
    
    let assetSelectEl;
    let vulSelectEl;
    let assetsTs = null;
    let vulTs = null;

    let formIsSubmitted = $state(false);
    let APIerror = $state(null);
    let formApiErrors = $state({});

    const asset_idField = field([], "", [required()]);
    const vulnerability_idField = field("vulnerability_id", "", [required()]);

    const myForm = svForm(asset_idField, vulnerability_idField);

    function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid) ||
            formApiErrors[field]
        );
    }

    $effect(() => {
        if (assets && assetsTs) {
            tick().then(() => assetsTs.sync());
        }
    });

    $effect(() => {
        if (custom_vuls && vulTs) {
            tick().then(() => vulTs.sync());
        }
    });

    async function handleSubmit(e) {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();

        for (let prop of customProps) {
            if (!prop.kind || !prop.name) {
                props_errors = "No se pudo guardar el hallazgo debido a que las propiedades deben tener tipo y valor. Por favor, complete los campos e intente nuevamente.";
                return false;
            }
        }

        formIsSubmitted = true;
        formApiErrors = {};

        if (!$myForm.valid) {
            notificate("422");
            return false;
        }

        let asset_ids = assetsTs ? assetsTs.getValue() : [];
        if (!Array.isArray(asset_ids)) {
            asset_ids = asset_ids ? [asset_ids] : [];
        }
        asset_ids = asset_ids.filter((id) => id && id !== "");

        let vul_id = vulTs ? vulTs.getValue() : "";

        if (asset_ids.length < 1 || !vul_id || vul_id === "none") {
            notificate("422");
            return false;
        }

        try {
            for (let id of asset_ids) {
                formData.asset_id = id;
                formData.vulnerability_id = vul_id;

                const customFnd = await findingService.save(formData, [], config);
                formIsSubmitted = false;
                formApiErrors = {};
                APIerror = null;

                for (let prop of customProps) {
                    if (Object.keys(prop).length > 0) {
                        let propReqData = {
                            finding_id: customFnd.id,
                            name: prop.name,
                            value: prop.value ? prop.value : null,
                            kind: prop.kind,
                            location: prop.location,
                        };
                        await findingService.saveProp(propReqData, [], {}).catch(() => false);
                    }
                }
                dispatch("save", { customFnd });
                onsave?.({ customFnd });
            }
        } catch (errors) {
            if (typeof errors?.detail === "string") {
                APIerror = translateErrorMessages(errors.detail, "Hallazgo");
            } else {
                formApiErrors = flatten422Errors(errors);
            }
            dispatch("save");
        }
    }

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formData.evidences = [];
        formData.customProps = [];
        APIerror = null;
        formIsSubmitted = false;
        props_errors = false;
        customProps = [];

        if (assetsTs) assetsTs.clear();
        if (vulTs) vulTs.clear();

        oncancel?.();
    }

    const addCustomPropInput = () => {
        if (!Array.isArray(customProps)) customProps = [];
        customProps = [...customProps, {}];
    };

    const removeCustomPropInput = (event) => {
        let i = typeof event === 'number' ? event : event?.detail;
        if (typeof i === 'number') {
            customProps.splice(i, 1);
            customProps = [...customProps];
        }
    };

    const pushCustomProps = (event) => {
        customProps = event?.detail || event;
    };

    const handleKeydown = (event) => {
        if (event.key === "Escape") {
            handleCloseModal();
        }
    };

    onMount(async () => {
        await tick();

        if (assetSelectEl) {
            assetsTs = new TomSelect(assetSelectEl, {
                plugins: ['remove_button'],
                placeholder: $format("buttons.search"),
                maxOptions: null,
                create: false,
            });
        }

        if (vulSelectEl) {
            vulTs = new TomSelect(vulSelectEl, {
                placeholder: $format("buttons.search"),
                maxOptions: null,
                create: false,
            });
        }
    });

    onDestroy(() => {
        if (assetsTs) assetsTs.destroy();
        if (vulTs) vulTs.destroy();
    });
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                <div class="mb-3 mt-3">
                    <label for="assetFieldMultiple" style="min-width: 77px;"
                        >{$format("asset.plural")}</label
                    >
                    <div>
                        <select
                            class="form-control"
                            id="assetFieldMultiple"
                            multiple="multiple"
                            name="assetsMultipleSelect"
                            bind:this={assetSelectEl}
                        >
                            <optgroup>
                                {#each assets as asset (asset.id)}
                                    <option value={asset.id}>
                                        {asset.name} ({$format(`asset.kind.${asset.kind}.singular`)})
                                    </option>
                                {/each}
                            </optgroup>
                        </select>
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <label for="findingFormVul"
                    >{$format("list.columns.vulnerability")}:</label
                >
                <select id="findingFormVul" bind:this={vulSelectEl}>
                    <option value="none"
                        >{$format("form.fields.select")}...</option
                    >
                    {#each custom_vuls as vul (vul.id)}
                        <option value={vul.id}
                            >{vul.title_es || vul.title} ({vul.id})</option
                        >
                    {/each}
                </select>
                {#if assets_are_loading}
                    <i class="fa fa-spin fa-sync-alt"></i>
                {/if}
                {#if APIerror}
                    <div class="mt-3 text-danger" style="font-size: 80%;">
                        {APIerror}
                    </div>
                {/if}
                {#if shouldShowFieldError($vulnerability_idField)}
                    {#if $myForm.hasError("vulnerability_id.required")}
                        <div class="invalid-feedback">Es requerido</div>
                    {/if}
                    {#if formApiErrors.vulnerability_id && formApiErrors.vulnerability_id.includes("value_error")}
                        <div class="invalid-feedback">
                            No es un valor válido
                        </div>
                    {/if}
                {/if}
            </div>

            <div class="mb-3">
                <label for="description">{$format("form.fields.description")}</label>
                <textarea
                    class="form-control"
                    id="description"
                    name="description"
                    placeholder={$format("list.columns.description")}
                    bind:value={formData.description}
                ></textarea>
                {#if APIerror}
                    <div class="mt-3 text-danger" style="font-size: 80%;">
                        {APIerror}
                    </div>
                {/if}
            </div>

            <div class="mb-3">
                <CustomPropsFormElement
                    config={{ add: true }}
                    customProps={customProps ? customProps : []}
                    onaddCustomProp={addCustomPropInput}
                    onpushCustomProps={pushCustomProps}
                    onremoveCustomProp={removeCustomPropInput}
                    on:addCustomProp={addCustomPropInput}
                    on:pushCustomProps={pushCustomProps}
                    on:removeCustomProp={removeCustomPropInput}
                />
                {#if props_errors}
                    <div class="text-danger">{props_errors}</div>
                {/if}
            </div>
        </div>

        <div class="card-footer">
            <button id="customFindingAddSubmit" type="submit" class="btn btn-primary">{$format("buttons.save")}</button>
            <button class="btn btn-default" type="button" onclick={handleCloseModal}>{$format("buttons.cancel")}</button>
        </div>
    </div>
</form>

<style>
    select {
        max-width: 400px;
    }
</style>